/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Tooltip, LinearProgress, IconButton, Avatar, Paper, Typography, Divider, Popper, ClickAwayListener } from '@material-ui/core'
import { BubbleChart, Label, Category, CheckCircleOutline, ArrowForward } from '@material-ui/icons';

import Actions from '../../../../fluid/Actions/ActionFactory'
import SampleAnnotation from '../../../Dedup/SampleAnnotation'

import { allowedByOpop } from '../../../Security/SecureCheck'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({
    small_avatar : {
        width : theme.spacing(4),
        height : theme.spacing(4)
    },
    connector : {
        flexGrow : 1,
        height : '3px'
    },
    connector_small : {
        flexGrow : 1,
        height : '2px'
    },
    "@keyframes in_progress" : {
        from: { opacity: 0.0 },
        to: { opacity: 1.0},
    },
    default : {},
    in_progress : {
        animation : "$in_progress 1s infinite linear"
    }
})

const stages = {
    "Model_Initialization" : {
        status_key : "model_initialization_status",
        status_object_key : "model_initialization_status_object",
        icon : BubbleChart,
        access_object : {
            operation : "/sainapse/model_initialization",
            method : "POST",
            operands : [
                {
                    attrName: "ic_name",
                    value_path : ['ic', 'name'],
                    value : null
                }
            ]
        }
    },
    "Labeling" : {
        status_key : "labeling_status",
        status_object_key : "labeling_status_object",
        icon : Label,
        access_object : {
            operation : "/sainapse/duplicate_detection/annotation_samples",
            method : "GET",
            operands : [
                {
                    attrName: "ic_name",
                    value_path : ['ic', 'name'],
                    value : null
                }
            ]
        }
    },
    "Training" : {
        status_key : "training_status",
        status_object_key : "training_status_object",
        icon : Category,
        access_object : {
            operation : "/sainapse/train",
            method : "POST",
            operands : [
                {
                    attrName: "ic_name",
                    value_path : ['ic', 'name'],
                    value : null
                }
            ]
        }
    }
}

const state_colors = {
    Disabled : {
        color : "rgba(0,0,0,0.5)",
        class_name : "default",
        connector : {
            variant : "determinate",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Ready : {
        color : "#2296f3",
        class_name : "default",
        connector : {
            variant : "determinate",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Scheduled : {
        color : "#2296f3",
        class_name : "scheduled",
        connector : {
            variant : "buffer",
            value : 10,
            valueBuffer : 50,
            color : 'primary'
        }
    },
    Queued : {
        color : "#2296f3",
        class_name : "in_progress",
        connector : {
            variant : "indeterminate",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    InProgress : {
        color : "#2296f3",
        class_name : "in_progress",
        connector : {
            variant : "indeterminate",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    PartiallyCompleted : {
        color : "#2296f3",
        class_name : "default",
        connector : {
            variant : "determinate",
            value : 50,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Aborted : {
        color : "#dc004e",
        class_name : "default",
        connector : {
            variant : "buffer",
            value : 50,
            valueBuffer : 0,
            color : 'secondary'
        }
    },
    Completed : {
        color : "#4caf50",
        class_name : "in_progress",
        connector : {
            variant : "determinate",
            value : 100,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Dirty : {
        color : "rgba(0,0,0,0.5)",
        class_name : "default",
        connector : {
            variant : "determinate",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    }
}

class TrainingStage extends Component {
    state = {
        training_stages : null,
        stage_status : [],
        selected_stage : null,
        selected_stage_open : false,
        selected_stage_anchor : null,
        error_stage: null,
        error_message : null,
        sample : false,
        open_annot : false
    }

    componentWillMount () {
        let stages_state = this.getStages()
        console.log("Operation Stages: ", stages_state)
        this.setState({stage_status : stages_state, training_stages : this.props.ic.operationAnnotations.find(op_annot => op_annot.type === this.props.op).training_stages}, () => console.log("Operation Stages and States : ", this.state))
    }

    componentDidUpdate (prevProps, prevState) {
        let stages_state = this.getStages()
        console.log("Operation Stages and States : ", stages_state)

        if (JSON.stringify(prevState.stage_status) !== JSON.stringify(stages_state)) {
            this.setState({stage_status : stages_state, selected_stage : null}, () => console.log("Operation Stages and States : ", this.state))
        }
    }

    getStageAccessObject = (stage) => {
        console.log("Stage : ", stages[stage])
        let access_object = stages[stage].access_object
        console.log("Stage Access : ", access_object)
        access_object.operands.map(operand => {
            console.log("Stage Operand : ", operand)
            let new_value = this.props
            console.log("Stage Val Value: ", new_value)
            operand.value_path.map(val => {
                new_value = new_value[val]
            })
            console.log("Stage Val Value: ", new_value)
            operand.value = new_value
            console.log("Stage Operand Value Fixed : ", operand)
        })

        return access_object
    }

    getStages = () => {
        let training_stages = this.props.ic.operationAnnotations.find(op_annot => op_annot.type === this.props.op).training_stages
        let stages_state = training_stages.map((stage, i) => {
            return this.getStageState(this.props.ic, stage.type, i, this.props.op)
        })

        return stages_state
    }

    getStageState = (ic, stage, index, operation) => {
        let stage_state = {
            type : stage,
            cur_status : null,
            prev_status : null
        }

        let op_status = ic.latest_stage_status.filter(log => log.operation === operation)
        
        if (op_status.length === 0) {
            stage_state.cur_status = ic.data_transfer_status !== 'Completed' ? "Disabled" : index === 0 ? "Ready" : "Dirty"
        } else {
            let op_status_for_stage = op_status.find(log => log.stage === stage)
            stage_state.cur_status = op_status_for_stage.status !== null ? op_status_for_stage.status : ic.data_transfer_status !== 'Completed' ? "Disabled" : index === 0 ? "Ready" : "Disabled"
        }

        let chron_events = ic[stages[stage].status_object_key].sort((a,b) => new Date(b.end_time) - new Date(a.end_time))
        let chron_events_for_op = chron_events.filter(log => log.operation === operation)
        if (chron_events_for_op.length > 0) {
            stage_state.prev_status = chron_events[0].status
        }

        return stage_state
    }

    calibrateStages = (stage_states) => {
        let ready_state_index = stage_states.findIndex(stage_state => stage_state.cur_status === 'Ready')
        console.log("Ready Stage Index :", ready_state_index)
        if (ready_state_index !== -1) {
            stage_states.map((stage_state, i) => {
                if (i > ready_state_index) {
                    stage_state.cur_status = 'Stale'
                }
            })
        }

        return stage_states
    }

    renderStage = (stage) => {
        const { classes } = this.props
        let stage_obj = this.state.stage_status.find(stage_status => stage_status.type === stage)
        let status = stage_obj.cur_status

        let training_stages = this.props.ic.operationAnnotations.find(op_annot => op_annot.type === this.props.op).training_stages
        console.log("Training Stages :", training_stages)
        console.log("Current Stage :", stage)
        let stage_annot = training_stages.find(t_stage => t_stage.type === stage).annotation
        console.log("Stage Annotation : ", stage_annot)

        return (
            <Fragment>
                <div>
                    {console.log("Stage allowed by OPOP : ", allowedByOpop(this.getStageAccessObject(stage)))}
                    <Tooltip title = {stage_annot + " " + status} placement = 'top'>
                        <IconButton 
                            size = {this.props.size} 
                            style = {{border : '1px solid ' + state_colors[status].color }} 
                            disabled = {allowedByOpop(this.getStageAccessObject(stage)) ? status === 'Disabled' ? true : false : true} 
                            onClick = {(event) => this.selectStage(stage, event)}>
                            {React.createElement(stages[stage].icon, {
                                style : { 
                                    color : state_colors[status].color,
                                    fontSize : this.props.size === 'small' ? '15px' : '20px'
                                },
                                classNames : classes[stages[stage].class_name]
                            })}
                        </IconButton>
                    </Tooltip>
                </div>
                <LinearProgress 
                    className = {this.props.size === 'small' ? classes.connector_small : classes.connector}
                    variant = {state_colors[status].connector.variant} 
                    value = {state_colors[status].connector.value} 
                    valueBuffer = {state_colors[status].connector.valueBuffer} 
                    color = {state_colors[status].connector.color} 
                />
            </Fragment>
        )
    }

    renderFinalCheck = () => {
        let training_cur_status = this.state.stage_status.find(stage => stage.type === 'Training').cur_status
        let training_prev_status = this.state.stage_status.find(stage => stage.type === 'Training').prev_status
        
        if (training_cur_status === "Completed") {
            return (
                <Fragment>
                    <Tooltip title = {this.props.ic.name + " is ready"}>
                        <IconButton 
                            size = {this.props.size} disableFocusRipple disableRipple disableTouchRipple>
                            <CheckCircleOutline
                                fontSize = {this.props.size}
                                style = {{
                                    margin : '5px',
                                    color : '#4caf50' 
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                </Fragment>
            )
        } else if (training_prev_status === 'Completed') {
            return (
                <Fragment>
                    <Tooltip title = {this.props.ic.name + " has an older trained model"}>
                        <CheckCircleOutline
                            fontSize = {this.props.size}
                            style = {{
                                margin : '5px'
                            }}
                            color = 'primary'
                        />
                    </Tooltip>
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <Tooltip title = {this.props.ic.name + " has not been trained"}>
                        <CheckCircleOutline
                            fontSize = {this.props.size}
                            style = {{
                                margin : '5px',
                                color : 'rgba(0,0,0,0.5)' 
                            }}
                        />
                    </Tooltip>
                </Fragment>
            )
        }
    }

    renderStages = () => {
        let training_stages = this.props.ic.operationAnnotations.find(op_annot => op_annot.type === this.props.op).training_stages
        
        if (training_stages.length > 0) {
            return (
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    {/* {this.renderDataTransferState()} */}
                    {training_stages.map(stage => this.renderStage(stage.type))}
                    {this.renderFinalCheck()}
                </div>
            )
        }
    }

    selectStage = (stage, event) => {
        console.log("Stage Event :", event)
        if (this.props.interaction) {
            if (this.state.selected_stage === stage) {
                this.setState({...this.state, selected_stage : null, selected_stage_anchor : null, selected_stage_open : false})
            } else {
                this.setState({...this.state, selected_stage : stage, selected_stage_anchor : event.currentTarget, selected_stage_open : true}, () => console.log("Training Stage Select : ", this.state))
            }
        }
    }

    renderStageDetail = () => {
        let stage_obj = stages[this.state.selected_stage]
        let stage_status = this.state.stage_status.find(stage_state => stage_state.type === this.state.selected_stage)

        let training_stages = this.props.ic.operationAnnotations.find(op_annot => op_annot.type === this.props.op).training_stages
        let cur_stage = training_stages.find(stage => stage.type === this.state.selected_stage)

        return (
            <Popper
                key = {"stage-select"}
                open={this.state.selected_stage_open}
                anchorEl={this.state.selected_stage_anchor}
                placement="right"
                modifiers={{
                    flip: {
                        enabled: true,
                    },
                    preventOverflow: {
                        enabled: false,
                        boundariesElement: 'scrollParent',
                    },
                    arrow: {
                        enabled: true,
                        element: this.state.arrowRef,
                    },
                }}
            >
                <ClickAwayListener onClickAway = {this.closePopper}>
                    <Paper elevation = {4} style = {{padding : '10px'}}>
                    <div style = {{width : '150px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Typography style = {{flexGrow : 1}} variant = 'subtitle2' color = 'textSecondary'>{cur_stage.annotation}</Typography>
                        <IconButton size = 'small' color = 'primary' disabled = {stage_status.cur_status === 'Disabled' ? true : false} onClick = {() => this.triggerStage(this.state.selected_stage)}>
                            <ArrowForward fontSize = 'small'/>
                        </IconButton>
                    </div>
                    {this.state.error_stage === this.state.selected_stage ? <Typography style = {{marginTop : '3px'}} variant = 'caption' color ='secondary'>{this.state.error_message}</Typography> : null}
                    </Paper>
                </ClickAwayListener>
            </Popper>
        )
    }

    closePopper = () => {
        this.setState({...this.state, selected_stage_anchor : null, selected_stage_open : false})
    }

    renderSamples = () => {
        if (this.state.sample) {
            return (
                <SampleAnnotation ic = {this.props.ic} op = {this.props.op} open = {this.state.open_annot} close = {this.closeAnnotation}/>
            )
        }
    }

    closeAnnotation = () => {
        this.setState({...this.state, open_annot : false, sample : false}, () => this.props.refresh())
    }

    triggerStage = (stage) => {
        if (stage === "Training") {
            this.triggerTrain()
        }

        if (stage === 'Model_Initialization') {
            this.triggerModelInitialization()
        }

        if (stage === "Labeling") {
            this.triggerSampleAnnotation()
        }
    }

    triggerModelInitialization = () => {
        Actions('http_request', {
            url : '/sainapse/model_initialization',
            method : 'post',
            data: [
                {
                  ic_name: this.props.ic.name,
                  operations: [this.props.op],
                  step_tag : this.props.step_tag
                },
            ]
        }).then(res => {
            this.props.refresh()
        }).catch(err => {
            this.setState({
                ...this.state,
                error_stage : this.state.selected_stage,
                error_message : "Error in initializing model"
            })
        })
    }

    triggerSampleAnnotation = () => {
        this.setState({...this.state, sample : true, open_annot : true})
    }

    triggerTrain = () => {
        Actions('http_request', {
            url: "/sainapse/train",
            method: "post",
            data: [
              {
                ic_name: this.props.ic.name,
                operations: [this.props.op],
              },
            ]
        }).then(res => {
            this.props.refresh()
        }).catch(err => {
            this.setState({
                ...this.state,
                error_stage : this.state.selected_stage,
                error_message : "Error in training this operation."
            })
        })
    }

    render() { 
        return (
            <Fragment>
                {this.renderStages()}
                {this.state.selected_stage !== null ? this.renderStageDetail() : null}
                {this.renderSamples()}
            </Fragment>
        );
    }
}
 
export default withStyles(styles)(TrainingStage);